module.exports = __webpack_public_path__ + "static/media/collection-background.2c9977f3.mp3";